import { render } from "./CloseSvg.vue?vue&type=template&id=b70503a8&scoped=true"
import script from "./CloseSvg.vue?vue&type=script&lang=ts"
export * from "./CloseSvg.vue?vue&type=script&lang=ts"

import "./CloseSvg.vue?vue&type=style&index=0&id=b70503a8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b70503a8"

export default script